import { getSiteConfig } from '@/utils/siteConfigStore';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

const valueIcons = ['ri-briefcase-line', 'ri-lightbulb-flash-line', 'ri-fire-line', 'ri-team-line'];

export default function CorporateCulture() {
  const { corporateCulture } = getSiteConfig();
  const { mission, vision, values } = corporateCulture;

  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('culture-bg-v1')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">

          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">企业文化</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                使命 · 愿景 · 价值观
              </h2>
              <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
                以文化凝聚人心，以信念驱动前行，构筑品牌持续发展的精神内核
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
            <ScrollReveal variant="fade-right">
              <div className="h-full bg-brand-gray rounded-2xl p-6 md:p-8 border border-brand-light/40 hover:border-brand-cream hover:shadow-md transition-all duration-300 group/card">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-deep text-white flex-shrink-0 group-hover/card:bg-brand-dark transition-colors duration-300">
                    <i className="ri-flag-2-line text-xl" />
                  </div>
                  <div>
                    <p className="text-brand-brown text-xs tracking-[0.2em] font-medium uppercase">MISSION</p>
                    <h3 className="text-xl font-bold text-brand-deep">{mission.title}</h3>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {mission.description}
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal variant="fade-left" delay={100}>
              <div className="h-full bg-brand-deep rounded-2xl p-6 md:p-8 border border-brand-dark/50 hover:border-brand-gold/30 hover:shadow-md transition-all duration-300 group/card">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-gold/15 text-brand-gold flex-shrink-0 group-hover/card:bg-brand-gold/25 transition-colors duration-300">
                    <i className="ri-eye-2-line text-xl" />
                  </div>
                  <div>
                    <p className="text-brand-gold/50 text-xs tracking-[0.2em] font-medium uppercase">VISION</p>
                    <h3 className="text-xl font-bold text-white">{vision.title}</h3>
                  </div>
                </div>
                <p className="text-white/70 text-sm leading-relaxed">
                  {vision.description}
                </p>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal variant="fade-up" delay={150}>
            <div className="text-center mb-10">
              <p className="text-brand-brown text-xs tracking-[0.2em] font-medium uppercase mb-1">VALUES</p>
              <h3 className="text-2xl font-bold text-brand-deep">核心价值观</h3>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((value, i) => (
              <ScrollReveal key={value.title} variant="fade-up" delay={200 + i * 100}>
                <div className="group relative bg-brand-gray rounded-2xl p-6 md:p-7 border border-brand-light/30 hover:border-brand-cream hover:shadow-md hover:bg-white transition-all duration-300 h-full">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white text-brand-brown mb-5 group-hover:bg-brand-deep group-hover:text-white transition-colors duration-300 flex-shrink-0">
                    <i className={`${valueIcons[i]} text-lg`} />
                  </div>

                  <div className="mb-4">
                    <h4 className="text-lg font-bold text-brand-deep mb-1">{value.title}</h4>
                    <p className="text-brand-brown text-xs font-medium">{value.subtitle}</p>
                  </div>

                  <p className="text-gray-500 text-sm leading-relaxed">
                    {value.desc}
                  </p>

                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-gold" />
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal variant="fade-up" delay={400}>
            <div className="mt-14 py-8 px-8 bg-brand-gray rounded-2xl border border-brand-light/30 text-center">
              <p className="text-brand-deep text-sm font-medium mb-1">
                「以文化凝聚人，以制度规范人，以事业成就人」
              </p>
              <p className="text-gray-400 text-xs">
                颜轻至始终坚信，唯有深厚的文化底蕴，才能孕育出经得起时间考验的品牌力量
              </p>
            </div>
          </ScrollReveal>

        </div>
      </div>
    </section>
  );
}